export enum AlertType {
	VERBATIM = 'VERBATIM',
	STUDIO = 'STUDIO'
}